/**
 * Configuración de Sentry para error tracking
 * 
 * Variables de entorno requeridas:
 * - VITE_SENTRY_DSN: DSN de Sentry (opcional, solo en producción)
 * - SENTRY_AUTH_TOKEN: Token para upload de source maps (opcional)
 * 
 * En producción, configurar en Vercel Dashboard > Settings > Environment Variables
 */

import * as Sentry from '@sentry/react';
import { logger } from './logger';

/**
 * Inicializar Sentry en el cliente
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.MODE || 'development';

  // Solo inicializar si hay DSN (producción)
  if (!dsn) {
    if (environment === 'production') {
      logger.warn('Sentry DSN no configurado. Error tracking deshabilitado.');
    }
    return;
  }

  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    // Filtros
    beforeSend(event, hint) {
      // Filtrar errores de desarrollo o extensiones del navegador
      if (environment === 'development') {
        return null;
      }
      
      // Filtrar errores de extensiones del navegador
      if (event.exception) {
        const error = hint.originalException;
        if (error instanceof Error) {
          const errorMessage = error.message || '';
          if (
            errorMessage.includes('chrome-extension://') ||
            errorMessage.includes('moz-extension://') ||
            errorMessage.includes('safari-extension://')
          ) {
            return null;
          }
        }
      }

      return event;
    },
  });
}

